import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { addLocale } from 'primereact/api';
import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { loading, setUsuarioLogin } from '../../actions';
import { FileUpload } from 'primereact/fileupload';
import { Image } from 'primereact/image';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { getDataConfiguracion, getPerfilUsuario, setUploadFoto, updateClaveProfiler, updateUsuarioProfiler } from '../../service/Usuario';
import { isNotVacioNull, isEmail, isRun, isLetras, isLetrasEspacio, minMax, isValue, isTelefono, getResultValidar } from '../../utilities/Validate'

export const PageProfile = () => {

    const objProfile = {
        fecha_nacimiento: '',
        cargo: {},
        universidad: {},
        titulo: '',
        postgrados: '',
        firmadigital: '',
        telefono: '',
        direccion: '',
        region: {},
        provincia: {},
        comuna: {},
        nombres: '',
        apellido_paterno: '',
        apellido_materno: '',
        email: '',
        foto: 'assets/layout/images/fotovacio.png'
    }

    const objPassword = {
        clave: '',
        nuevaClave: ''
    }
    const objValiPass = {
        clave: { estado: true, mensaje: 'Valor requerido', validar: isNotVacioNull, minmax: false },
        nuevaClave: { estado: true, mensaje: 'Valor requerido', validar: isNotVacioNull, minmax: false }
    }

    const objValidate = {
        fecha_nacimiento: { estado: true, mensaje: 'Valor requerido', validar: isNotVacioNull, minmax: false },
        cargo: { estado: true, mensaje: 'Valor requerido', validar: isNotVacioNull, minmax: false },
        universidad: { estado: true, mensaje: 'Valor requerido', validar: isNotVacioNull, minmax: false },
        titulo: { estado: null, mensaje: '', validar: isValue, minmax: false },
        postgrados: { estado: null, mensaje: '', validar: isValue, minmax: false },
        firmadigital: { estado: null, mensaje: '', validar: isValue, minmax: false },
        telefono: { estado: null, mensaje: 'Error formato', validar: isTelefono, minmax: false, required: false },
        direccion: { estado: null, mensaje: '', validar: isValue, minmax: false },
        region: { estado: true, mensaje: 'Valor requerido', validar: isNotVacioNull, minmax: false },
        provincia: { estado: true, mensaje: 'Valor requerido', validar: isNotVacioNull, minmax: false },
        comuna: { estado: true, mensaje: 'Valor requerido', validar: isNotVacioNull, minmax: false },
        email: { estado: true, mensaje: 'Error formato email con longitud max. 45', validar: isEmail, minmax: true, min: 1, max: 45, required: true },
        nombres: { estado: true, mensaje: '', validar: isValue, minmax: false },
        apellido_paterno: { estado: true, mensaje: '', validar: isValue, minmax: false },
        apellido_materno: { estado: true, mensaje: '', validar: isValue, minmax: false },
        foto: { estado: true, mensaje: '', validar: isValue, minmax: false },
    }

    const toast = useRef(null);
    const dispatch = useDispatch();
    const [submitted, setSubmitted] = useState(false);
    const [submittedClave, setSubmittedClave] = useState(false);
    const [profiler, setProfiler] = useState(objProfile);
    const [profilerValidate, setProfilerValidate] = useState(objValidate);
    const [claveData, setClaveData] = useState(objPassword);
    const [claveDataValidate, setClaveDataValidate] = useState(objValiPass);

    const [regiones, setRegiones] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [comunas, setComunas] = useState([]);

    const [cargos, setCargos] = useState([]);
    const [universidades, setUniversidades] = useState([]);

    const { usuario, colegio, anio } = useSelector(state => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio
    }));

    const loadIni = async () => {

        dispatch(loading(true));

        setRegiones(usuario.general.region);

        let data = await getDataConfiguracion('cargos', usuario.token);
        if (data.error == 0) {
            setCargos(data.cargos);
        } else {
            console.log(data.mensaje);
        }

        data = await getDataConfiguracion('universidades', usuario.token);
        if (data.error == 0) {
            setUniversidades(data.universidades);
        } else {
            console.log(data.mensaje);
        }

        dispatch(loading(false));
    }

    const loadGetPerfilUsuario = async () => {

        let data = await getPerfilUsuario(colegio.id, usuario.token);
        if (data.error == 0) {
            let _detalla = { ...objProfile };
            let profe = data.profesional;

            let fecha_nacimiento = new Date(profe.fecha_nacimiento)
            fecha_nacimiento.setMinutes(fecha_nacimiento.getMinutes() + fecha_nacimiento.getTimezoneOffset())
            _detalla.fecha_nacimiento = fecha_nacimiento;
            _detalla.cargo = { id: profe.idcargo, cargo: profe.cargo };
            _detalla.universidad = { id: profe.iduniversidad, universidad: profe.universidad };

            _detalla.titulo = profe.titulo === null ? '' : profe.titulo;
            _detalla.postgrados = profe.postgrados === null ? '' : profe.postgrados;
            _detalla.firmadigital = profe.firmadigital === null ? '' : profe.firmadigital;
            _detalla.telefono = profe.telefono === null ? '' : profe.telefono;
            _detalla.direccion = profe.direccion === null ? '' : profe.direccion;
            _detalla.nombres = profe.nombres === null ? '' : profe.nombres;
            _detalla.apellido_paterno = profe.apellido_paterno === null ? '' : profe.apellido_paterno;
            _detalla.apellido_materno = profe.apellido_materno === null ? '' : profe.apellido_materno;
            _detalla.email = profe.email === null ? '' : profe.email;

            _detalla.foto = (profe.foto === null || profe.foto === '') ? _detalla.foto : profe.foto;

            _detalla.region = profe.idregion === null ? _detalla.region : usuario.general.region.find(o => o.idregion === profe.idregion)
            _detalla.provincia = profe.idprovincia === null ? _detalla.provincia : usuario.general.provincia.find(o => o.idprovincia === profe.idprovincia)
            _detalla.comuna = profe.idcomuna === null ? _detalla.comuna : usuario.general.comuna.find(o => o.idcomuna === profe.idcomuna)

            setProfiler(_detalla);
        } else {
            console.log(data.mensaje);
        }

        dispatch(loading(false));
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _detalla = { ...profiler };
        _detalla[`${name}`] = val;
        setProfiler(_detalla);
    }

    const onInputChangeClave = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _detalla = { ...claveData };
        _detalla[`${name}`] = val;
        setClaveData(_detalla);
    }

    useEffect(() => {
        loadIni();
    }, []);

    useEffect(() => {
        loadGetPerfilUsuario();
    }, [usuario.comuna]);


    useEffect(() => {

        if (profiler.region !== undefined && profiler.region !== '' && profiler.region !== null) {
            setProvincias(usuario.general.provincia.filter(o => o.idregion == profiler.region.idregion));
            setComunas([]);
        } else {
            setProvincias([]);
            setComunas([]);
            let _ubigeo = { ...profiler };
            _ubigeo['provincia'] = '';
            _ubigeo['comuna'] = '';
            setProfiler(_ubigeo);
        }

    }, [profiler.region]);

    useEffect(() => {
        if (profiler.provincia !== undefined && profiler.provincia !== '' && profiler.provincia !== null) {
            setComunas(usuario.general.comuna.filter(o => o.idprovincia == profiler.provincia.idprovincia));
        } else {
            setComunas([]);
            let _ubigeo = { ...profiler };
            _ubigeo['comuna'] = '';
            setProfiler(_ubigeo);
        }

    }, [profiler.provincia]);

    const monthNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} style={{ lineHeight: 1 }} />;
    }

    const yearNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} className="ml-2" style={{ lineHeight: 1 }} />;
    }

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    const onBasicUpload = () => {
        toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded with Basic Mode' });
    }

    const chooseOptions = { label: 'Adjuntar' };
    const uploadOptions = { label: 'Guardar', icon: 'pi pi-upload', className: 'p-button-success' };
    const cancelOptions = { label: 'Cancelar', icon: 'pi pi-times', className: 'p-button-danger' };

    const subirFoto = async (files) => {
    
        dispatch(loading(true));
        let data = await setUploadFoto(files.files[0], usuario.token);
        if (data.error == 0) {
            let _detalla = { ...profiler };
            _detalla['foto'] = data.url;
            setProfiler(_detalla);
            let usu = { ...usuario };
            usu.foto = data.url;
            dispatch(setUsuarioLogin(usu));
            localStorage.setItem('dat', JSON.stringify(usu));
            toast.current.show({ severity: 'success', summary: 'OK', detail: "Foto subido con éxito!", life: 3000 });
            files.options.clear()
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
            } else {
                console.log('Error');
            }
        }
        dispatch(loading(false));
    }

    const saveProfile = async () => {
        setSubmitted(true);
        if (colegio.id !== undefined) {
            let validado = getResultValidar(profiler, profilerValidate);

            setProfilerValidate(validado.result);
            if (validado.registra) {
                dispatch(loading(true));
                let data = await updateUsuarioProfiler(usuario.superusuario ? 0 : colegio.id, usuario.token, profiler);
                if (data.error == 0) {
                    toast.current.show({ severity: 'success', summary: 'OK', detail: "Registros Actualizados!", life: 3000 });
                } else {
                    if (data.error == 1) {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
                    } else {
                        console.log('Error');
                    }
                }
                dispatch(loading(false));
            }
        }
    }

    const accept = async () => {

        dispatch(loading(true));
        let data = await updateClaveProfiler(usuario.superusuario ? 0 : colegio.id, usuario.token, claveData);
        if (data.error == 0) {
            toast.current.show({ severity: 'success', summary: 'OK', detail: "Contraseña Actualizada!", life: 3000 });
            let dd = { ...claveData }
            dd.clave = '';
            dd.nuevaClave = '';
            setClaveData(dd);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
            } else {
                console.log('Error');
            }
        }
        dispatch(loading(false));

    }


    const confirmUpdateClave = () => {

        setSubmittedClave(true);
        if (colegio.id !== undefined) {
            let validado = getResultValidar(claveData, claveDataValidate);
            setClaveDataValidate(validado.result);
            if (validado.registra) {
                confirmDialog({
                    message: '¿Estas seguro de actualizar tu clave?',
                    header: 'Confirmar!',
                    icon: 'pi pi-info-circle',
                    acceptClassName: 'p-button-success',
                    accept
                });
            }
        }
    };

    return (

        <div className="p-formgrid p-grid p-col-12 card p-fluid p-pt-4" >
            <Toast ref={toast} />

            <div className="p-col-12 p-md-12 p-lg-8">
                <h5 className="p-pl-2"> Datos Personales</h5>
                <div className="p-grid p-col-12">
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="name2">NOMBRES</label>
                        <InputText disabled type="text" value={profiler.nombres} onChange={(e) => onInputChange(e, 'nombres')} required className={classNames({ 'p-invalid': submitted && !profilerValidate.nombres.estado })} />
                        {submitted && !profilerValidate.nombres.estado && <small className="p-error">{objValidate.nombres.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="email2">APELLIDO PATERNO</label>
                        <InputText disabled type="text" value={profiler.apellido_paterno} onChange={(e) => onInputChange(e, 'apellido_paterno')} required className={classNames({ 'p-invalid': submitted && !profilerValidate.apellido_paterno.estado })} />
                        {submitted && !profilerValidate.apellido_paterno.estado && <small className="p-error">{objValidate.apellido_paterno.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="email2">APELLIDO MATERNO</label>
                        <InputText disabled type="text" value={profiler.apellido_materno} onChange={(e) => onInputChange(e, 'apellido_materno')} required className={classNames({ 'p-invalid': submitted && !profilerValidate.apellido_materno.estado })} />
                        {submitted && !profilerValidate.apellido_materno.estado && <small className="p-error">{objValidate.apellido_materno.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="name2">REGIÓN</label>
                        <Dropdown value={profiler.region} options={regiones} onChange={(e) => onInputChange(e, 'region')} optionLabel="region" filter showClear filterBy="region" placeholder="Seleccionar..." />
                        {submitted && !profilerValidate.region.estado && <small className="p-error">{objValidate.region.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="name2">PROVINCIA</label>
                        <Dropdown value={profiler.provincia} options={provincias} onChange={(e) => onInputChange(e, 'provincia')} optionLabel="provincia" filter showClear filterBy="provincia" placeholder="Seleccionar..." />
                        {submitted && !profilerValidate.provincia.estado && <small className="p-error">{objValidate.provincia.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="name2">COMUNA</label>
                        <Dropdown value={profiler.comuna} options={comunas} onChange={(e) => onInputChange(e, 'comuna')} optionLabel="comuna" filter showClear filterBy="comuna" placeholder="Seleccionar..." />
                        {submitted && !profilerValidate.comuna.estado && <small className="p-error">{objValidate.comuna.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="txtDireccion">DIRECCIÓN</label>
                        <InputText type="text" value={profiler.direccion} onChange={(e) => onInputChange(e, 'direccion')} required className={classNames({ 'p-invalid': submitted && !profilerValidate.direccion.estado })} />
                        {submitted && !profilerValidate.direccion.estado && <small className="p-error">{objValidate.direccion.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="name2">FECHA NACIMIENTO</label>
                        <Calendar id="spanish" value={profiler.fecha_nacimiento} onChange={(e) => onInputChange(e, 'fecha_nacimiento')} locale="es" dateFormat="dd/mm/yy" monthNavigator yearNavigator yearRange="1960:2023" showIcon monthNavigatorTemplate={monthNavigatorTemplate} yearNavigatorTemplate={yearNavigatorTemplate} />
                        {submitted && !profilerValidate.fecha_nacimiento.estado && <small className="p-error">{objValidate.fecha_nacimiento.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="email2">TELEFONO</label>
                        <InputText id="email2" type="text" value={profiler.telefono} onChange={(e) => onInputChange(e, 'telefono')} required className={classNames({ 'p-invalid': submitted && !profilerValidate.telefono.estado })} />
                        {submitted && !profilerValidate.telefono.estado && <small className="p-error">{objValidate.telefono.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="name2">EMAIL</label>
                        <InputText type="text" value={profiler.email} onChange={(e) => onInputChange(e, 'email')} required className={classNames({ 'p-invalid': submitted && !profilerValidate.email.estado })} />
                        {submitted && !profilerValidate.email.estado && <small className="p-error">{objValidate.email.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="email2">CARGO</label>
                        <Dropdown value={profiler.cargo} options={cargos} onChange={(e) => onInputChange(e, 'cargo')} optionLabel="cargo" filter showClear filterBy="cargo" placeholder="Seleccionar..." />
                        {submitted && !profilerValidate.cargo.estado && <small className="p-error">{objValidate.cargo.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="email2">UNIVERSIDAD</label>
                        <Dropdown value={profiler.universidad} options={universidades} onChange={(e) => onInputChange(e, 'universidad')} optionLabel="universidad" filter showClear filterBy="universidad" placeholder="Seleccionar..." />
                        {submitted && !profilerValidate.universidad.estado && <small className="p-error">{objValidate.universidad.mensaje}</small>}
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="name2">TITULO</label>
                        <InputText type="text" value={profiler.titulo} onChange={(e) => onInputChange(e, 'titulo')} required className={classNames({ 'p-invalid': submitted && !profilerValidate.titulo.estado })} />
                        {submitted && !profilerValidate.titulo.estado && <small className="p-error">{objValidate.titulo.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="name2">POSTGRADOS</label>
                        <InputText type="text" value={profiler.postgrados} onChange={(e) => onInputChange(e, 'postgrados')} required className={classNames({ 'p-invalid': submitted && !profilerValidate.postgrados.estado })} />
                        {submitted && !profilerValidate.postgrados.estado && <small className="p-error">{objValidate.postgrados.mensaje}</small>}
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="name2">FIRMA DIGITAL</label>
                        <InputText disabled type="text" value={profiler.firmadigital} onChange={(e) => onInputChange(e, 'firmadigital')} required className={classNames({ 'p-invalid': submitted && !profilerValidate.firmadigital.estado })} />
                        {submitted && !profilerValidate.firmadigital.estado && <small className="p-error">{objValidate.firmadigital.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-10 p-mt-2">

                    </div>
                    <div className="p-col-12 p-md-6 p-lg-2 p-mt-3">
                        <Button label="Actualizar" onClick={saveProfile}></Button>
                    </div>

                </div>
                <h5 className="p-pl-2"> Password</h5>
                <div className="p-grid p-col-12">
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="name2">Contraseña</label>
                        <InputText type="password" value={claveData.clave} onChange={(e) => onInputChangeClave(e, 'clave')} required className={classNames({ 'p-invalid': submittedClave && !claveDataValidate.clave.estado })} />
                        {submittedClave && !claveDataValidate.clave.estado && <small className="p-error">{claveDataValidate.clave.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                        <label htmlFor="email2">Nueva Contraseña</label>
                        <InputText type="password" value={claveData.nuevaClave} onChange={(e) => onInputChangeClave(e, 'nuevaClave')} required className={classNames({ 'p-invalid': submittedClave && !claveDataValidate.nuevaClave.estado })} />
                        {submittedClave && !claveDataValidate.nuevaClave.estado && <small className="p-error">{claveDataValidate.nuevaClave.mensaje}</small>}
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-2 p-mt-4 p-mb-5" style={{ paddingTop: '4px' }}>
                        <Button label="Actualizar" onClick={confirmUpdateClave}></Button>
                    </div>

                </div>
            </div>
            <div className="p-col-12 p-md-12 p-lg-4 ">
                <div className="p-grid">
                    <div className="card" width="100%" style={{ textAlign: 'center', width: '100%' }}>
                        <h5>Foto:</h5>
                        <Image src={profiler.foto} alt="Image" width="250" height="260" />
                        <FileUpload mode="basic" name="demo" auto={false} customUpload={true} chooseOptions={chooseOptions} uploadOptions={uploadOptions} uploadHandler={subirFoto} accept="image/*" maxFileSize={1000000} onUpload={onBasicUpload} />
                         
                      {/*  <FileUpload mode="advanced" name="demo" multiple={false} auto={false} customUpload={true} chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} onUpload={onBasicUpload} uploadHandler={subirFoto} accept="image/*" maxFileSize={1000000} />*/}
                    </div>

                </div>
            </div>
        </div>

    )

}